import { render, staticRenderFns } from "./CreditDetails.vue?vue&type=template&id=8947bc8e&scoped=true&"
import script from "./CreditDetails.vue?vue&type=script&lang=js&"
export * from "./CreditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8947bc8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8947bc8e')) {
      api.createRecord('8947bc8e', component.options)
    } else {
      api.reload('8947bc8e', component.options)
    }
    module.hot.accept("./CreditDetails.vue?vue&type=template&id=8947bc8e&scoped=true&", function () {
      api.rerender('8947bc8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Credit/CreditDetails.vue"
export default component.exports